<template>
    <Head title="Support" />
    <div class="px-4 md:px-8 py-8 w-full max-w-9xl mx-auto" data-page="support">
        <div class="relative overflow-hidden bg-white dark:bg-slate-800 py-16">
            <div class="relative px-6 lg:px-8">
                <div class="mx-auto max-w-prose text-lg">
                    <h1>
                        <span
                            class="block text-center text-lg font-semibold text-orange"
                        >
                            Need Support?
                        </span>
                        <span
                            class="mt-2 block text-center text-xl lg:text-3xl font-bold lg:leading-8 tracking-tight text-gray-900 dark:text-slate-100"
                        >
                            Get in touch with our customer support team
                        </span>
                    </h1>
                </div>

                <div
                    class="prose lg:prose-lg prose-indigo dark:prose-invert mx-auto mt-6 text-gray-500 dark:text-slate-300"
                >
                    <div class="border-b border-gray-200 dark:border-slate-700 mt-8"></div>

                    <p>
                        Having an issue with My10x? Fill out the form below to
                        open a support ticket with our team, and we'll be happy
                        to help you troubleshoot. To help us resolve issues as
                        quickly as possible, please submit one issue per ticket.
                    </p>
                    <p>
                        We'll reply to your message by email as soon as we can.
                        Our team is available weekdays during business hours,
                        9:00 AM–5:00 PM ET.
                    </p>
                    <SupportForm />
                    <div class="border-b border-gray-200 dark:border-slate-700 mt-8"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import SupportForm from '@/components/support-form.vue';
</script>
